import React from 'react'
import { FieldProps } from '../FormDuuf'

// Elements
import Label from '../elements/Label'

const SectionField: React.FC<FieldProps> = ({ fieldId, data }) => (
  <div className={`form-duuf-group form-duuf-group-${data.type.toLowerCase()}`}>
    {!!data.label && <Label fieldId={fieldId} data={data} />}
    {!!data.description && <div className="form-duuf-description">{data.description}</div>}
  </div>
)

export default SectionField
